// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.test-detail-section {
  border: 1px solid #e3e8ef;
  border-radius: 4px;
  padding: 0.65rem;
  background: #ffffff;
}

.test-detail-title {
  margin: 0 0 0.55rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #3f4954;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.test-detail-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.65rem 1rem;
}

.test-detail-fields--inputs {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.test-detail-fields--results {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.test-detail-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.test-detail-label {
  margin: 0;
  font-size: 0.85rem;
  color: #555;
  font-weight: 600;
}

.test-detail-subtitle {
  margin: 0 0 0.45rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #475569;
}

@media (max-width: 768px) {
  .test-detail-fields--inputs,
  .test-detail-fields--results {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 480px) {
  .test-detail-fields--inputs,
  .test-detail-fields--results {
    grid-template-columns: minmax(0, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-overview/test-details/job-request-test-naf-chemistry-detail.component.scss"],"names":[],"mappings":"AAAA;EAAuB,yBAAA;EAA2B,kBAAA;EAAoB,gBAAA;EAAkB,mBAAA;AAKxF;;AAJA;EAAqB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,cAAA;EAAgB,yBAAA;EAA2B,sBAAA;AAa3H;;AAZA;EAAsB,aAAA;EAAe,2DAAA;EAA6D,iBAAA;AAkBlG;;AAjBA;EAA8B,gDAAA;AAqB9B;;AApBA;EAA+B,gDAAA;AAwB/B;;AAvBA;EAAqB,aAAA;EAAe,sBAAA;EAAwB,WAAA;AA6B5D;;AA5BA;EAAqB,SAAA;EAAW,kBAAA;EAAoB,WAAA;EAAa,gBAAA;AAmCjE;;AAlCA;EAAwB,mBAAA;EAAqB,kBAAA;EAAoB,gBAAA;EAAkB,sBAAA;EAAwB,yBAAA;EAA2B,cAAA;AA2CtI;;AAzCA;EACC;;IAC+B,gDAAA;EA6C9B;AACF;AA3CA;EACC;;IAC+B,qCAAA;EA8C9B;AACF","sourcesContent":[".test-detail-section { border: 1px solid #e3e8ef; border-radius: 4px; padding: 0.65rem; background: #ffffff; }\n.test-detail-title { margin: 0 0 0.55rem; font-size: 0.85rem; font-weight: 700; color: #3f4954; text-transform: uppercase; letter-spacing: 0.02em; }\n.test-detail-fields { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 0.65rem 1rem; }\n.test-detail-fields--inputs { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n.test-detail-fields--results { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n.test-detail-field { display: flex; flex-direction: column; gap: 0.3rem; }\n.test-detail-label { margin: 0; font-size: 0.85rem; color: #555; font-weight: 600; }\n.test-detail-subtitle { margin: 0 0 0.45rem; font-size: 0.78rem; font-weight: 700; letter-spacing: 0.02em; text-transform: uppercase; color: #475569; }\n\n@media (max-width: 768px) {\n\t.test-detail-fields--inputs,\n\t.test-detail-fields--results { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 480px) {\n\t.test-detail-fields--inputs,\n\t.test-detail-fields--results { grid-template-columns: minmax(0, 1fr); }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
